import { WithStatePaginatedTable } from '@delmonicos/shared-design-system-react/src/components/with-state-paginated-table/with-state-paginated-table';
import { TransformedPaginatedData } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/transform-api-paginated-response/transformed-paginated-data.model';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { OnChangeFn, SortingState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { StateEnum } from '@model/enum/state.enum';

import {
  TOKEN_TRANSACTION_LIST_COLUMN_LIST,
  TOKEN_TRANSACTION_LIST_COLUMN_ORDER,
  TOKEN_TRANSACTION_LIST_COLUMN_VISIBILITY,
} from './token-transaction-list.config';

interface TokenTransactionListViewProps {
  paginationLimit: number;
  paginationLimitList: number[];
  paginationState: StateEnum;
  paginationSorting: SortingState;
  resource?: TransformedPaginatedData<TransactionModel>;
  onPaginationLimitChange: (paginationLimitNext: number) => void;
  onPaginationPageChange: (paginationOffsetNext: number) => void;
  onPaginationSortingChange?: OnChangeFn<SortingState>;
}

export const TokenTransactionListView = ({
  paginationLimit,
  paginationLimitList,
  paginationState,
  paginationSorting,
  resource,
  onPaginationLimitChange,
  onPaginationPageChange,
  onPaginationSortingChange,
}: TokenTransactionListViewProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <WithStatePaginatedTable
      paginatedData={resource}
      state={paginationState}
      sorting={paginationSorting}
      columns={TOKEN_TRANSACTION_LIST_COLUMN_LIST}
      columnOrder={TOKEN_TRANSACTION_LIST_COLUMN_ORDER}
      columnVisibility={TOKEN_TRANSACTION_LIST_COLUMN_VISIBILITY}
      limit={paginationLimit}
      limitList={paginationLimitList}
      errorMessage={t('$.transaction-list.error')}
      onLimitChange={onPaginationLimitChange}
      onPageChange={onPaginationPageChange}
      onSortingChange={onPaginationSortingChange}
    />
  );
};
